// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import DataTable, { DataTablePresentationProps } from "@insite/mobius/DataTable";
import { DataTableBody, DataTableCell, DataTableHeader, DataTableRow, Typography } from "@insite/mobius/index";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import constants from "@store/constants";
import { useReturnSlipById } from "@store/Framework/Store/Store/Pages/ReturnSlip/ReturnSlipHooks";
import useQueryString from "@toolkit/Framework/Common/Hooks/useQueryString";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface ReturnSlipTemplateStyles {
    pageWrapper?: InjectableCss;
    dataTable?: DataTablePresentationProps;
    signedLinesWrapper?: InjectableCss;
    forOfficeUseTitle?: TypographyPresentationProps;
    btCompanyName?: TypographyPresentationProps;
}

export const returnSlipTemplateStyles: ReturnSlipTemplateStyles = {
    pageWrapper: {
        css: css`
            &.rma-return-slip-page {
                font-family: Arial, Helvetica, Arial, Verdana, sans-serif;
                color: #464646;
            }
            &.rma-return-slip-page .rma-return-slip-wrapper {
                box-sizing: border-box;
                width: 612pt;
                min-height: 792pt;
                padding: 18pt;
                background-color: #ffffff;
                font-size: 8pt;
            }
            &.rma-return-slip-page .rma-return-slip-table {
                border: 0.0625rem solid #000000;
            }
            &.rma-return-slip-page .rma-return-slip-table tr {
                border-bottom: 0.0625rem solid #000000;
            }
            &.rma-return-slip-page .rma-return-slip-table tr:last-child {
                border-bottom: 0;
            }
            &.rma-return-slip-page .rma-return-slip-table td,
            &.rma-return-slip-page .rma-return-slip-table th {
                padding: 2px 10px;
                border-right: 0.0625rem solid #000000;
            }
            &.rma-return-slip-page .rma-return-slip-table td:last-child,
            &.rma-return-slip-page .rma-return-slip-table th:last-child {
                border-bottom: 0;
            }
            &.rma-return-slip-page .invoice-infos {
                float: right;
                max-width: 250pt;
                border-right: 0;
            }
            &.rma-return-slip-page .invoice-products {
                width: 100%;
            }
            &.rma-return-slip-page .invoice-products th {
                text-align: center;
            }
            &.rma-return-slip-page .return-reasons {
                width: 100%;
            }
            &.rma-return-slip-page .office-use-table-wrapper {
                vertical-align: bottom;
            }
            &.rma-return-slip-page .office-use-table {
                width: 100%;
            }
            &.rma-return-slip-page .office-use-table tr {
                border-bottom: 0;
            }
            &.rma-return-slip-page .right {
                text-align: right;
            }
            &.rma-return-slip-page .left {
                text-align: left;
            }
            &.rma-return-slip-page .center {
                text-align: center;
            }
            &.rma-return-slip-page .main-block {
                width: 100%;
                margin-bottom: 30px;
            }
            &.rma-return-slip-page .border {
                border: 0.0625rem solid #000000;
            }
            &.rma-return-slip-page .label {
                color: #211359;
                font-family: Arial, Helvetica, Arial, Verdana, sans-serif;
                font-size: 8pt;
                font-weight: 700;
                text-transform: uppercase;
            }
            &.rma-return-slip-page .practice-informations {
                width: 100%;
                height: 150px;
                padding: 10px;
                font-weight: 700;
            }
            &.rma-return-slip-page .highlight-text {
                color: #211359;
                font-weight: 700;
            }
            &.rma-return-slip-page .product-tables-notes {
                padding-bottom: 30px;
                margin-top: 10px;
                font-weight: 700;
                text-align: center;
            }
            &.rma-return-slip-page .complete-box-explication {
                padding: 10px 10px 30px;
            }
            &.rma-return-slip-page .complete-box-text {
                font-weight: 700;
            }
            &.rma-return-slip-page .signed-line {
                padding-bottom: 5px;
                padding-left: 10px;
                border-bottom: 1px solid #000000;
                font-weight: 700;
            }
            &.rma-return-slip-page .signed-line:last-child {
                border-bottom: 0;
            }
            &.rma-return-slip-page .driver-signature-title {
                padding: 10px;
            }
            &.rma-return-slip-page .office-use-table-text {
                font-weight: 700;
                text-transform: uppercase;
            }
            &.rma-return-slip-page .main-title {
                padding-top: 10px;
                font-size: 38pt;
                font-weight: 700;
                text-align: right;
                text-transform: uppercase;
            }
            &.rma-return-slip-page .list-item {
                margin-bottom: 0;
            }
            &.rma-return-slip-page .rma-data-table {
                float: right;
            }
            &.rma-return-slip-page .rma-data-table td {
                padding: 2px 10px;
            }
            &.rma-return-slip-page .checkbox {
                width: 10px;
                height: 10px;
                margin: 0 auto;
            }
            @media only screen {
                &.rma-return-slip-page {
                    min-height: 100vh;
                    padding-top: 2em;
                    padding-bottom: 4pt;
                    background-color: #525659;
                }
                &.rma-return-slip-page .rma-return-slip-wrapper {
                    margin: 0 auto;
                }
            }
        `,
    },
    dataTable: {
        css: css``,
        cssOverrides: {
            header: css`
                box-sizing: inherit;
                height: unset;
                border-bottom: unset;
                white-space: normal;
                background: ${getColor("common.background")};
                border-bottom: unset;
                vertical-align: top;
                align-self: flex-start;
                padding: 0;
                font-weight: inherit;
                text-align: left;
            `,
            head: css``,
            body: css``,
            row: css``,
            evenRow: css`
                background: ${getColor("common.background")};
            `,
            cell: css`
                box-sizing: inherit;
                height: unset;
                border-bottom: unset;
                white-space: normal;
                vertical-align: top;
                align-self: flex-start;
                padding: 0;
                font-weight: inherit;
                text-align: left;
            `,
        },
    },
    signedLinesWrapper: {
        css: css`
            p {
                margin-bottom: 1em;
            }

            p:last-child {
                margin-bottom: 0;
            }
        `,
    },
    forOfficeUseTitle: {
        css: css`
            text-align: center;
        `,
    },
    btCompanyName: {
        css: css`
            margin-bottom: 1em;
        `,
    },
};

const styles = returnSlipTemplateStyles;

const ReturnSlipTemplate = (props: Props) => {
    const { id: widgetId } = props;
    const { returnSlipId } = useQueryString();
    const returnSlip = useReturnSlipById(returnSlipId || "");

    return (
        <StyledWrapper {...styles.pageWrapper} className="rma-return-slip-page">
            <StyledWrapper className="rma-return-slip-wrapper" data-test-selector="returnSlip_container">
                <DataTable {...styles.dataTable} className="main-block">
                    <DataTableBody>
                        <DataTableRow>
                            <DataTableCell colSpan={2}>
                                <Zone contentId={widgetId} zoneName="Heading" />
                            </DataTableCell>
                            <DataTableCell rowSpan={5} align="right">
                                <DataTable {...styles.dataTable} cellSpacing={0}>
                                    <DataTableBody className="rma-return-slip-table invoice-infos">
                                        <DataTableRow>
                                            <DataTableCell className="label">{translate("Account No")}:</DataTableCell>
                                            <DataTableCell>{returnSlip?.customerNumber.substring(3)}</DataTableCell>
                                        </DataTableRow>
                                        <DataTableRow>
                                            <DataTableCell className="label">{translate("Invoice No")}:</DataTableCell>
                                            <DataTableCell>{returnSlip?.invoiceNumber}</DataTableCell>
                                        </DataTableRow>
                                        <DataTableRow>
                                            <DataTableCell className="label">
                                                {translate("Invoice Date")}:
                                            </DataTableCell>
                                            <DataTableCell>{returnSlip?.invoiceDateFormatted}</DataTableCell>
                                        </DataTableRow>
                                        {returnSlip?.returnReference && (
                                            <DataTableRow>
                                                <DataTableCell className="label">
                                                    {translate("Returns Ref")}:
                                                </DataTableCell>
                                                <DataTableCell>{returnSlip.returnReference}</DataTableCell>
                                            </DataTableRow>
                                        )}
                                        <DataTableRow>
                                            <DataTableCell className="label">
                                                {translate("Practice Contact")}:
                                            </DataTableCell>
                                            <DataTableCell>{returnSlip?.practiceContact}</DataTableCell>
                                        </DataTableRow>
                                    </DataTableBody>
                                </DataTable>
                            </DataTableCell>
                        </DataTableRow>
                        <DataTableRow>
                            <DataTableCell colSpan={2} className="highlight-text">
                                {translate("Customer Services: 03300 947 587")}
                            </DataTableCell>
                        </DataTableRow>
                        <DataTableRow>
                            <DataTableCell colSpan={2}>&nbsp;</DataTableCell>
                        </DataTableRow>
                        <DataTableRow>
                            <DataTableCell rowSpan={7}>
                                <StyledWrapper className="practice-informations border">
                                    <Typography {...styles.btCompanyName} forwardAs="p">
                                        {returnSlip?.btCompanyName}
                                    </Typography>
                                    <Typography  forwardAs="div">
                                        {returnSlip?.btAddress1}
                                    </Typography>
                                    {returnSlip?.btAddress2 && (
                                        <Typography  forwardAs="div">
                                            {returnSlip?.btAddress2}
                                        </Typography>
                                    )}
                                    <Typography
                                        
                                        forwardAs="div"
                                    >{`${returnSlip?.btCity || ""}, ${returnSlip?.btState || ""}, ${returnSlip?.btPostalCode || ""}`}</Typography>
                                </StyledWrapper>
                            </DataTableCell>
                            <DataTableCell>&nbsp;</DataTableCell>
                        </DataTableRow>
                        <DataTableRow>
                            <DataTableCell>&nbsp;</DataTableCell>
                        </DataTableRow>
                        <DataTableRow>
                            <DataTableCell colSpan={2} className="main-title">
                                {translate("Returns Slip")}
                            </DataTableCell>
                        </DataTableRow>
                        <DataTableRow>
                            <DataTableCell colSpan={2}>&nbsp;</DataTableCell>
                        </DataTableRow>
                        <DataTableRow>
                            <DataTableCell colSpan={2} className="highlight-text right">
                                {translate("All products returned must be accompanied by a return slip.")}
                            </DataTableCell>
                        </DataTableRow>
                        <DataTableRow>
                            <DataTableCell colSpan={2}>&nbsp;</DataTableCell>
                        </DataTableRow>
                        <DataTableRow>
                            <DataTableCell colSpan={2} className="right">
                                <strong>{translate("Printed on")}:&nbsp;</strong>&nbsp;
                                {returnSlip?.generatedOnFormatted}
                            </DataTableCell>
                        </DataTableRow>
                    </DataTableBody>
                </DataTable>
                <StyledWrapper className="main-block">
                    <DataTable {...styles.dataTable} cellSpacing={0} className="rma-return-slip-table invoice-products">
                        <DataTableBody>
                            <DataTableRow>
                                <DataTableHeader className="label">{translate("Product Code")}</DataTableHeader>
                                <DataTableHeader className="label">{translate("Product Description")}</DataTableHeader>
                                <DataTableHeader className="label">{translate("Fridge Ref")}</DataTableHeader>
                                <DataTableHeader className="label">{translate("Return Qty")}</DataTableHeader>
                                <DataTableHeader className="label">{translate("Return Value")}</DataTableHeader>
                                <DataTableHeader className="label">{translate("Product Indicator")}</DataTableHeader>
                                <DataTableHeader className="label">{translate("Return Code")}</DataTableHeader>
                                <DataTableHeader className="label">{translate("Order No")}</DataTableHeader>
                                <DataTableHeader className="label">{translate("Order Date")}</DataTableHeader>
                            </DataTableRow>
                            {returnSlip?.lines.map(line => (
                                <DataTableRow key={line.productNumber}>
                                    <DataTableCell>{line.productNumberFormatted}</DataTableCell>
                                    <DataTableCell width="30%">
                                        <Typography  forwardAs="div">
                                            {line.productDescription}
                                        </Typography>
                                        <Typography  forwardAs="div">
                                            <strong>{translate("Batch no")}&nbsp;</strong>&nbsp;{line.batchNumber}
                                        </Typography>
                                        <Typography  forwardAs="div">
                                            <strong>{translate("Expiry on")}&nbsp;</strong>&nbsp;
                                            {line.expiryOnFormatted}
                                        </Typography>
                                    </DataTableCell>
                                    <DataTableCell>{line.fridgeReference}</DataTableCell>
                                    <DataTableCell>{line.rmaQtyRequested}</DataTableCell>
                                    <DataTableCell>{line.rmaProductLineTotalPriceDisplay}</DataTableCell>
                                    <DataTableCell>{line.productIndicator}</DataTableCell>
                                    <DataTableCell>{line.reasonCodeWithComments}</DataTableCell>
                                    <DataTableCell>{line.orderNumber}</DataTableCell>
                                    <DataTableCell>{line.orderDateFormatted}</DataTableCell>
                                </DataTableRow>
                            ))}
                        </DataTableBody>
                    </DataTable>
                    <StyledWrapper className="product-tables-notes">
                        <Typography  forwardAs="div">
                            {translate(
                                "This return Slip Should be given to your driver along with the items listed within 24 hours.",
                            )}
                        </Typography>
                        <Typography  forwardAs="div">
                            {translate("Please print two copies, retain one copy for your records")}
                        </Typography>
                    </StyledWrapper>
                </StyledWrapper>
                <DataTable {...styles.dataTable} className="main-block">
                    <DataTableBody>
                        <DataTableRow>
                            <DataTableCell width="45%">
                                <StyledWrapper className="border">
                                    <StyledWrapper className="complete-box-explication">
                                        <Typography  as="div" className="label">
                                            {translate("Please Complete...")}
                                        </Typography>
                                        <Typography  as="p" className="complete-box-text">
                                            {translate(
                                                "I confirm that these returned products were stored in accordance with datasheet recommendations whilst in our possession.",
                                            )}
                                        </Typography>
                                    </StyledWrapper>
                                    <StyledWrapper {...styles.signedLinesWrapper}>
                                        <Typography  as="p" className="signed-line">
                                            {translate("Signed")}
                                        </Typography>
                                        <Typography  as="p" className="signed-line">
                                            {translate("Print Name")}
                                        </Typography>
                                        <Typography  as="p" className="signed-line">
                                            {translate("Date")}
                                        </Typography>
                                    </StyledWrapper>
                                </StyledWrapper>
                            </DataTableCell>
                            <DataTableCell width="10%"></DataTableCell>
                            <DataTableCell width="45%" align="right" valign="top">
                                <DataTable
                                    {...styles.dataTable}
                                    cellSpacing={0}
                                    className="rma-return-slip-table return-reasons"
                                >
                                    <DataTableBody>
                                        <DataTableRow>
                                            <DataTableHeader colSpan={2}>
                                                <Typography forwardAs="span" className="label">
                                                    {translate("Reason Codes")}
                                                </Typography>
                                            </DataTableHeader>
                                        </DataTableRow>
                                        {returnSlip?.reasons.map(reason => (
                                            <DataTableRow key={reason.code}>
                                                <DataTableCell>{reason.description}</DataTableCell>
                                                <DataTableCell className="center">{reason.code}</DataTableCell>
                                            </DataTableRow>
                                        ))}
                                    </DataTableBody>
                                </DataTable>
                            </DataTableCell>
                        </DataTableRow>
                    </DataTableBody>
                </DataTable>
                <DataTable {...styles.dataTable} className="main-block">
                    <DataTableBody>
                        <DataTableRow>
                            <DataTableCell width="45%" height="100%" valign="top" className="border">
                                <Typography
                                    
                                    className="driver-signature-title label"
                                    forwardAs="div"
                                >
                                    {translate("Driver Signature...")}
                                </Typography>
                                <StyledWrapper {...styles.signedLinesWrapper}>
                                    <Typography  className="signed-line" forwardAs="p">
                                        {translate("Signed")}
                                    </Typography>
                                    <Typography  className="signed-line" forwardAs="p">
                                        {translate("Print Name")}
                                    </Typography>
                                    <Typography  className="signed-line" forwardAs="p">
                                        {translate("Date")}
                                    </Typography>
                                </StyledWrapper>
                            </DataTableCell>
                            <DataTableCell width="10%"></DataTableCell>
                            <DataTableCell width="45%" className="office-use-table-wrapper">
                                <Typography {...styles.forOfficeUseTitle} forwardAs="div">
                                    {translate("For Office Use Only")}
                                </Typography>
                                <DataTable
                                    {...styles.dataTable}
                                    cellSpacing={0}
                                    className="rma-return-slip-table office-use-table"
                                >
                                    <DataTableBody>
                                        <DataTableRow>
                                            <DataTableCell>&nbsp;</DataTableCell>
                                            <DataTableCell className="office-use-table-text center">
                                                {translate("Yes")}
                                            </DataTableCell>
                                            <DataTableCell className="office-use-table-text center">
                                                {translate("No")}
                                            </DataTableCell>
                                        </DataTableRow>
                                        <DataTableRow>
                                            <DataTableCell className="office-use-table-text">
                                                {translate("Credit")}
                                            </DataTableCell>
                                            <DataTableCell className="center">
                                                <div className="checkbox border"></div>
                                            </DataTableCell>
                                            <DataTableCell className="center">
                                                <div className="checkbox border"></div>
                                            </DataTableCell>
                                        </DataTableRow>
                                        <DataTableRow>
                                            <DataTableCell className="office-use-table-text">
                                                {translate("Stock Adjustment")}
                                            </DataTableCell>
                                            <DataTableCell className="center">
                                                <div className="checkbox border"></div>
                                            </DataTableCell>
                                            <DataTableCell className="center">
                                                <div className="checkbox border"></div>
                                            </DataTableCell>
                                        </DataTableRow>
                                    </DataTableBody>
                                </DataTable>
                            </DataTableCell>
                        </DataTableRow>
                    </DataTableBody>
                </DataTable>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ReturnSlipTemplate,
    definition: {
        group: constants.widgetGroup.returnSlip,
        allowedContexts: [constants.pageType.returnSlipPage],
        displayName: "Return Slip Template",
    },
};

export default widgetModule;
